import { render, staticRenderFns } from "./verifyTwoFac.vue?vue&type=template&id=755065c8&"
import script from "./verifyTwoFac.vue?vue&type=script&lang=js&"
export * from "./verifyTwoFac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports